import { render, staticRenderFns } from "./BalancePorTipoMovimiento.vue?vue&type=template&id=5d716f1f&scoped=true"
import script from "./BalancePorTipoMovimiento.vue?vue&type=script&lang=js"
export * from "./BalancePorTipoMovimiento.vue?vue&type=script&lang=js"
import style0 from "./BalancePorTipoMovimiento.vue?vue&type=style&index=0&id=5d716f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d716f1f",
  null
  
)

export default component.exports